export default {
  postureReport: "자세 보고서",
  postureData: "자세 데이터",
  postureDataContrast: "자세 데이터 대조",
  postureRiskContrast: "자세 위험 대조",
  postureDataTrend: "자세 데이터 추세",
  postureRiskTrend: "자세 위험 추세",
  postureLogData: "자세 로그 데이터",
  lateralhead: "측면 머리 기울기",
  unevenshoulder: "어깨 불균형",
  scoliosis: "척추 측만증",
  unevenhip: "골반 측면 기울기",
  xleg: "X 모양 다리",
  oleg: "O 모양 다리",
  roundedshoulder: "둥근 어깨",
  kneehyperextension: "무릎 과도 신전",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "머리 앞으로",
  toTheLeft: "（왼쪽）",
  toTheRight: "（오른쪽）",
  bracketsLeft: "（L）",
  bracketsRight: "（R）",
  bracketsNormal: "（정상）",
  leg: "다리",
  legLeft: "다리 (L)",
  legRight: "다리 (R)",
  riskAssessment: "위험 평가",
  muscleState: "근육 상태",
  muscleStateDesc: "이상 근육 상태가 발견되지 않았습니다",
  testTime: "테스트 시간",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "항목",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "모아레 이미지",
  lAbnormalRisk: "L 위험",
  mAbnormalRisk: "M 위험",
  hAbnormalRisk: "",
  highRisk: "고위험",
  riskAnalysis: "위험 분석",
  conclusionRecommendation: "결론 및 권고",
  solution: "해결책",
  movePosition: "점을 클릭하여 위치를 이동합니다",
  confirmTheClose: "아직 저장되지 않았습니다. 닫기를 확인하시겠습니까?",
  closeInfo: "아직 저장되지 않았습니다. 닫기를 확인하시겠습니까?",
  share: "공유",
  front: "앞면",
  side: "측면",
  back: "뒤쪽",
  otherSide: "다른 측면",
  points: "점",
  angle: "각도",
  name: "이름",
  gender: "성별",
  male: "남성",
  female: "여성",
  age: "나이",
  year: "살",
  height: "키",
  weight: "몸무게",
  time: "시간",
  patientId: "환자 ID",
  save: "저장",
  saveModify: "저장 수정",
  print: "인쇄",
  cancel: "취소",
  zoomIn: "확대",
  zoomOut: "축소",
  ok: "좋아요",
  return: "뒤로",
  empty: "",
  unknown: "미지",
  succeedToCopy: "복사 성공",
  succeedToSave: "저장 성공",
  headForwardDistance: "머리 전방 거리",
  pelvisForwardTilt: "골반 전방 경사",
  wristHipDistanceLeft: "손목에서 엉덩이까지의 거리 (왼쪽)",
  wristHipDistanceRight: "손목에서 엉덩이까지의 거리 (오른쪽)",
  evaluator: "평가자",
  reportDate: "보고서날",
  introduction: "소개",
  doctorIntroDefault: "전문 분야: 재활 의학, 자세평 및 교정 | 경력: 5년 이상 | 전문성: 부상 재활, 자세 교정, 통증 관리",
  recoveryLog: "회복 로그",
  returnToReport: "보고서로 돌아가기",
  loading: "로딩 중...",
  showToolbox: "도구 상자 표시",
  hideToolbox: "도구 상자 숨기기",
};

